import React from 'react';

import { useStyles } from '../../Home/Intro/styles/introCardStyles';

export const GlobePointer = () => {
  const classes = useStyles();
  return (
    <svg
      viewBox='0 0 35 35'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classes.svgIcon}
    >
      <g clipPath='url(#clip0_3201_2018)'>
        <path
          d='M0.974609 17.7207C0.974609 16.2531 1.16055 14.832 1.5125 13.4707H9.68711C9.56094 14.6926 9.49453 15.9543 9.48125 17.2559L2.3293 19.3543C1.85781 19.4938 1.45937 19.7195 1.12734 20.0117C1.02773 19.2613 0.974609 18.4977 0.974609 17.7207ZM2.20977 11.3457C4.20195 6.425 8.42539 2.65313 13.6316 1.27852C11.9383 3.54961 10.6234 7.10234 9.95938 11.3457H2.20977ZM11.6129 16.625C11.6395 15.5426 11.7125 14.4867 11.8188 13.4707H24.1238C24.2699 14.8254 24.343 16.2465 24.343 17.7207C24.343 19.1949 24.2633 20.616 24.1238 21.9707H19.6879L20.5246 19.1285C21.2352 16.7113 18.9906 14.4602 16.5668 15.1707L11.6129 16.625ZM12.1109 11.3457C12.516 8.92852 13.1402 6.79023 13.9039 5.05703C14.6012 3.48984 15.3781 2.3543 16.1285 1.63711C16.8723 0.933203 17.4898 0.720703 17.9746 0.720703C18.4594 0.720703 19.077 0.933203 19.8207 1.63711C20.5711 2.3543 21.348 3.48984 22.0453 5.05703C22.8156 6.78359 23.4332 8.92188 23.8383 11.3457H12.1109ZM16.1617 33.8309C16.2281 33.6848 16.2879 33.5254 16.341 33.3594L19.0637 24.0957H23.8383C23.4332 26.5129 22.809 28.6512 22.0453 30.3777C21.348 31.9449 20.5711 33.0805 19.8207 33.7977C19.077 34.5082 18.4594 34.7207 17.9746 34.7207C17.4965 34.7207 16.8922 34.5148 16.1617 33.8309ZM22.3176 1.27852C27.5172 2.65313 31.7473 6.425 33.7328 11.3457H25.9832C25.3191 7.10234 24.0043 3.54961 22.3109 1.27852H22.3176ZM22.3176 34.1562C24.0109 31.8852 25.3191 28.3324 25.9898 24.0891H33.7395C31.7473 29.0098 27.5238 32.7816 22.3242 34.1562H22.3176ZM26.2621 13.4707H34.4367C34.7887 14.832 34.9746 16.2531 34.9746 17.7207C34.9746 19.1883 34.7887 20.6094 34.4367 21.9707H26.2621C26.4016 20.6027 26.4746 19.1816 26.4746 17.7207C26.4746 16.2598 26.4016 14.8387 26.2621 13.4707Z'
          fill='#63CDE5'
        />
        <path
          className={classes.globePointer}
          d='M17.1714 17.2091L3.56475 21.2068C2.6417 21.479 2.52881 22.7474 3.39209 23.179L7.19717 25.0849C7.28349 25.1314 7.36982 25.1845 7.44287 25.2509L1.59912 31.0947C0.769043 31.9247 0.769043 33.2728 1.59912 34.1029C2.4292 34.9329 3.77725 34.9329 4.60732 34.1029L10.4511 28.2591C10.5175 28.3322 10.5772 28.4119 10.6171 28.5048L12.5229 32.3099C12.9546 33.1732 14.2229 33.0603 14.4952 32.1372L18.4929 18.5372C18.7319 17.7337 17.9815 16.9833 17.1714 17.2158V17.2091Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_3201_2018'>
          <rect
            width='34'
            height='34'
            fill='white'
            transform='translate(0.974609 0.720703)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};
